export default "__VITE_ASSET__9lFHA_bM__"